exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".arc[data-v-692875aa]:hover{transform:scale(1.2);cursor:pointer}#chart[data-v-692875aa]{margin-bottom:70px}.svg-line-container[data-v-692875aa]{display:inline-block;position:relative;width:100%;padding-bottom:100%;vertical-align:top;overflow:visible}.svg-content[data-v-692875aa]{display:inline-block;position:absolute;overflow:visible!important;top:0;left:0}.label-text[data-v-692875aa]{font-size:20px;text-anchor:middle;text-transform:uppercase}polyline[data-v-692875aa]{opacity:.3;stroke:#000;stroke-width:2px;fill:none}.labelName[data-v-692875aa]{font-size:.8em;font-style:italic}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/vue-loader/lib??vue-loader-options!./src/components/paywall/dashboard/PieChart.vue?vue&type=style&index=0&id=692875aa&prod&scoped=true&lang=css&
// module id = 1278
// module chunks = 0